import Others from './Other';

export default Others;
